import { Component, Input } from "@angular/core";
import { EffectivenessModel } from "../../shared/models";
import { TranslocoPipe } from "@jsverse/transloco";
import { DateFormatPipe } from "@app/shared/pipes/date-format.pipe";

@Component({
    selector: "eff-detail-breadcrumb-info",
    templateUrl: "./eff-detail-breadcrumb-info.component.html",
    styleUrls: ["./eff-detail-breadcrumb-info.component.scss"],
    imports: [TranslocoPipe, DateFormatPipe]
})
export class EffDetailBreadcrumbInfoComponent {
    @Input() effectivenessModel: EffectivenessModel;
}
